import _ from 'lodash';
import { useEffect, useState } from 'react';

interface Props<T> {
  items: T[];
  initialSize?: number;
}

export const useServerlessList = <T>({ items, initialSize }: Props<T>) => {
  //Paginazione
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(initialSize ?? 15);

  const [list, setList] = useState<T[]>([]);

  useEffect(() => {
    setList(_.slice(items, page * pageSize, page * pageSize + pageSize));
  }, [items, page, pageSize]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
  };

  return {
    list,
    count: items.length,
    page,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
  };
};
